module.exports = __webpack_public_path__ + "static/media/behandlungsraum.12052b74.jpg";